<!--
 * @Author: your name
 * @Date: 2020-06-29 16:10:51
 * @LastEditTime: 2020-08-10 15:01:05
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \heating-wechat-web\src\components\Index\Index.vue
--> 
<template>
  <div class="insuranceSucceed-wrap">
    <div class="insuranceSucceed-wrap">
      <div class="insuranceSucceed-back"></div>
      <div class="insuranceSucceed-top">
        <div class="insuranceSucceed-title">缴费成功</div>
        <div class="insuranceSucceed-text"><span></span>  您的房屋{{userPayInfo.houseInfo.building_name}}{{userPayInfo.houseInfo.unit_number}}单元{{userPayInfo.houseInfo.hourse_number}}于{{date}}在承德市双滦区兴业热力有限公司的微信平台缴费成功!</div>
        <div class="insuranceSucceed-text"><span></span>跑漏险保费:{{userPayInfo.insuranceMoney}}元</div>
        <div class="insuranceSucceed-hint">
          <div style="width: 8px;line-height: 0.12rem;"><span style="background:#FF8888;"></span></div>
          <div>
            <div style="margin-left: 0.09rem;">跑漏险使用电子收据并通过微信告知缴费结果和下载电子收据链接后，需要保单请联系：{{riskLinkmanName}}</div>
            <div style="margin-top: 0.03rem;margin-left: 0.09rem;">联系电话: {{riskLinkmanPhone}}</div>
          </div>
        </div>
      </div>
      <div class="insuranceSucceed-button">
        <el-button type="primary" style="background: #007B83;border:none;padding:4%" @click="goHome" >返回主页面</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  data(){
    return{
      userPayInfo:{
        houseInfo:[]
      },//用户的支付信息
      date:moment().format("YYYY年MM月DD日"),
      riskLinkmanPhone:'',// 跑漏险联系人电话
      riskLinkmanName:''
    }
  },

  methods:{
    goHome(){
      this.$router.replace({
        name:'index'
      })
    },
    async getSystemConfig(){
      const res = await this.$http.get(`${this.$url.globalurl}/systemConfig/${2}`);
      this.riskLinkmanPhone = res.result[0].risk_linkman_phone;
      this.riskLinkmanName = res.result[0].risk_linkman_name;
    }
  },

  mounted(){
    if(this.$route.query){
      this.userPayInfo = this.$route.query;
    }
    document.title = "缴费结果";
    this.getSystemConfig();
  }
  }
</script>
<style lang='scss' scoped>
@import url(insuranceSucceed.scss);
</style>
